import styled, { css } from 'styled-components';
import { fontSize } from '../../../../mixins';
import { mobileResponsiveXs } from '../common.style';
var StyledH3 = styled.h3.withConfig({
  displayName: "H3style__StyledH3",
  componentId: "sc-1e4415j-0"
})(["margin:0;outline:transparent;font-family:", ";", ";", ";", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.font.family.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return fontSize(theme.font.size.lg);
}, color, bold, light, accent, size);

function color(_ref3) {
  var theme = _ref3.theme,
      isOnDarkBg = _ref3.isOnDarkBg;
  var fontColor = isOnDarkBg ? theme.color.white : theme.color.black;
  return css(["color:", ";"], fontColor);
}

function bold(_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant === 'bold' && css(["font-weight:", ";"], theme.font.weight.bold);
}

function light(_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return variant === 'light' && css(["font-weight:", ";"], theme.font.weight.light);
}

function accent(_ref6) {
  var variant = _ref6.variant,
      theme = _ref6.theme,
      isOnDarkBg = _ref6.isOnDarkBg;
  return variant === 'accent' && css(["font-weight:", ";font-family:", ";color:", ";"], theme.font.weight.regular, theme.font.family.accent, isOnDarkBg ? theme.color.white : theme.color.primary);
}

function size(_ref7) {
  var theme = _ref7.theme,
      shouldResize = _ref7.shouldResize;

  if (shouldResize) {
    return mobileResponsiveXs(theme.font.size.mobile.lg, theme.font.size.lg, theme.font.lineHeight.mobile.lg);
  }

  return css(["", ";"], fontSize(theme.font.size.lg));
}

export default StyledH3;